<template>
  <branding-field
    v-bind="$attrs"
    :border="!hasColorChosen"
  >
    <v-menu
      slot="field"
      v-model="showMenu"
      :bottom="menuBottom"
      :left="menuLeft"
      :right="menuRight"
      :top="menuTop"
      :close-on-content-click="false"
      :max-width="$vuetify.breakpoint.xs ? $vuetify.breakpoint.width - 48 : 480"
      class="colorfield-box"
      :class="{bordered: hasColorChosen}"
      :style="{background: !hasColorChosen ? 'initial' : color}"
      offset-y
      lazy
    >
      <v-layout
        slot="activator"
        align-center
        :style="{'min-height': $attrs['min-height'] || '200px'}"
      >
        <v-layout
          column
          align-center
        >
          <v-icon
            v-if="!hasColorChosen"
            x-large
          >
            colorize
          </v-icon>
          <div
            v-if="!hasColorChosen"
            data-cy="no-color-chosen-yet-hint"
            class="mt-2 body-2 grey--text text--darken-2"
          >
            {{ $t('brandingColorSelect') }}
          </div>
        </v-layout>
      </v-layout>
      <v-card>
        <v-card-text>
          <color-picker
            :key="colorPickerId + showMenu"
            :color="color || defaultColor"
            :color-palette="colorPalette"
            :show-color-palette="showColorPalette"
            :ignore-alpha="ignoreAlpha"
            @close="showMenu = false"
            @changed="updateChosenColor"
          />
        </v-card-text>
      </v-card>
    </v-menu>
  </branding-field>
</template>

<script>
import BrandingField from '@/components/BrandingField';
import ColorPicker from '@/components/ColorPicker';

export default {
  components: {
    BrandingField,
    ColorPicker,
  },
  inheritAttrs: false,
  props: {
    /** Specific to this field type. */
    color: {
      type: String,
      default: null,
    },
    /** To avoid Vue confusing colorpicker widgets, pass a unique ID here. */
    colorPickerId: {
      type: String,
      default: null,
    },
    defaultColor: {
      type: String,
      default: '#ffffff',
    },
    colorPalette: {
      type: Array[String],
      default: () => {
        return [
          '#5BC0EB',
          '#FDE74C',
          '#9BC53D',
          '#C3423F',
          '#000000',
          '#FFFFFF',
          '#808080',
        ];
      },
    },
    showColorPalette: {
      type: Boolean,
      default: true,
    },
    menuTop: {
      type: Boolean,
      default: false,
    },
    menuBottom: {
      type: Boolean,
      default: false,
    },
    menuLeft: {
      type: Boolean,
      default: false,
    },
    menuRight: {
      type: Boolean,
      default: false,
    },
    ignoreAlpha: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    hasColorChosen() {
      return this.color !== null;
    },
  },
  methods: {
    updateChosenColor(color) {
      // To be able to use :color.sync.
      this.$emit('update:color', color);
      // To be able to attach additional behaviour e.g. update other colorfields.
      this.$emit('changed', color);
    },
  },
};
</script>

<style scoped>
.colorfield-box {
  border: 1px solid transparent;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandingColorfield.vue